import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useEffect } from "react";
import { UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useGetHook";
import usePatchHook from "../../hooks/usePatchHook";
import CreateIcon from "../../icons/CreateIcon";
import { queryClient } from "../../root.component";
import Spinner from "../../shared/Spinner";
import { INavigation } from "../../types/interface";

const EditNavigationComponent = loadable(
  () => import("../../components/Navigation/Edit")
);

export default function EditComponent() {
  const { id } = useParams();

  const { data: navigationInfo, isLoading: isGettingNavigationInfo } =
    useGetHook<INavigation>({
      url: `${APIS.NAVIGATION}${id}/`,
      queryKey: [`get-navigation-details-${id}`],
    });

  const { mutateAsync: updateNavigation, isLoading: isUpdationNavigation } =
    usePatchHook({
      queryKey: [`update-navigation-details-${id}`],
      navigateURL: "/website-builder/navigation",
    });

  const handleUpdate = async (
    data: INavigation,
    setError: UseFormSetError<INavigation>
  ): Promise<void> => {
    try {
      const url = `${APIS.NAVIGATION}${id}/`;
      await updateNavigation({
        url,
        formData: {
          ...data,
          pages: data?.pages?.id,
        },
        setError,
      });
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  useEffect(() => {
    queryClient.resetQueries();
  }, [id]);

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Update Navigation
        </span>
      </div>
      {isGettingNavigationInfo ? (
        <Spinner />
      ) : (
        <EditNavigationComponent
          handleUpdate={handleUpdate}
          isUpdatingNavigation={isUpdationNavigation}
          navigationInfo={navigationInfo}
        />
      )}
    </>
  );
}
